import { apiFunction } from "../../apiCall/function"

export const getSubject = async (code) => {
  return await apiFunction("question/0?lang=" + code, "get", {}, false, 'body')
}